import { Link } from 'react-router-dom';
import SectionTitle from '@/components/feature/SectionTitle';
import { episodes } from '@/mocks/manga';

export default function EpisodesPreview() {
  const items = episodes.slice(0, 6);
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <SectionTitle
            kicker="分集剧情"
            title="每话讲了什么，一目了然"
            desc="按话整理的关键情节速览，追更前先扫一眼，剧情节奏稳稳拿捏。"
          />
          <Link
            to="/episodes"
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-primary-300 px-4 py-2 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100"
          >
            查看全部分集
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((ep) => (
            <article key={ep.id} className="flex items-start gap-4 rounded-lg bg-background-100 p-4">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-500 font-heading text-lg text-background-50">
                {ep.id}
              </span>
              <div className="min-w-0">
                <div className="flex flex-wrap items-center gap-2">
                  <h3 className="font-heading text-base text-foreground-900">{ep.title}</h3>
                  <span className="rounded-full bg-accent-100 px-2 py-0.5 text-xs text-accent-800">{ep.tag}</span>
                </div>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{ep.summary}</p>
                <p className="mt-2 text-xs text-foreground-400">{ep.season} · 第 {ep.id} 话</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}